import * as React from 'react';
import { ClearDiv } from '..';

export class Col2Col8Col2d extends React.PureComponent<React.PropsWithChildren<{}>, {}> {
	public render() {
		return (
			<ClearDiv className='row'>
				<div className='col-lg-2 d-none d-lg-block' />
				<div className='col-lg-8 col-sm-12'>{this.props.children}</div>
				<div className='col-lg-2 d-none d-lg-block' />
			</ClearDiv>
		);
	}
}
